<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="closeModal()">Annuler</ion-button>
      </ion-buttons>
      <ion-title>Changer la remorque</ion-title>
    </ion-toolbar>

    <ion-toolbar>
      <ion-searchbar
        placeholder="Rechercher..."
        v-model="searchQuery"
        autofocus="true"
      ></ion-searchbar>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-list>
      <ion-item
        button
        v-for="dumpBody in filteredDumpBodies"
        :key="dumpBody.id"
        @click="selectDumpBody(dumpBody)"
      >
        <ion-label>{{ dumpBody.name }}</ion-label>
      </ion-item>

      <ion-item v-if="filteredDumpBodies.length === 0 && searchQuery">
        <ion-label class="ion-text-center opacity-50">
          <p>Aucune remorque trouvée</p>
        </ion-label>
      </ion-item>

      <ion-item v-if="filteredDumpBodies.length === 0 && !searchQuery">
        <ion-label class="ion-text-center opacity-50">
          <p>Saisissez le nom d'une remorque</p>
        </ion-label>
      </ion-item>
    </ion-list>
  </ion-content>
</template>

<script>
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonSearchbar,
  IonList,
  IonItem,
  IonLabel,
  modalController,
} from '@ionic/vue';
import { sendErrorToast, sendSuccessToast } from '@/services/utils/toastUtils';
import { getParams } from '@/services/users';
import axios from 'axios';

export default {
  name: 'ChangeDumpBodyModal',
  components: {
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonSearchbar,
    IonList,
    IonItem,
    IonLabel,
  },
  props: {
    dumpBodies: Array,
    eventKind: String,
    eventId: Number,
  },

  data() {
    return {
      searchQuery: '',
    };
  },

  computed: {
    filteredDumpBodies() {
      const query = this.searchQuery.toLowerCase().trim();

      if (!this.dumpBodies || !this.dumpBodies.length) return [];
      if (!query) return this.dumpBodies;

      return this.dumpBodies.filter(d => d.name.toLowerCase().includes(query));
    },
  },

  methods: {
    closeModal(data = null) {
      modalController.dismiss(data);
    },

    async updateDumpBody(dumpBodyId) {
      const config = await getParams();

      return axios.patch(
        `/driver/dump-body/${this.eventId}/${this.eventKind}`,
        { dump_body_id: dumpBodyId },
        config,
      );
    },

    async selectDumpBody(dumpBody) {
      try {
        await this.updateDumpBody(dumpBody.id);

        sendSuccessToast('Remorque mise à jour');
        modalController.dismiss(true);
      } catch (error) {
        sendErrorToast('Erreur lors de la mise à jour de la remorque');
        modalController.dismiss(false);
      }
    },
  },
};
</script>
